import React from 'react'
import PropTypes from 'prop-types'
import WrappedDrawer from '@/components/WrappedDrawer'
import ShiftList from './ShiftList'

class ShiftListDrawer extends React.Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    storeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }

  render () {
    const { children, storeId } = this.props
    return (
      <WrappedDrawer
        children={children}
        title="班次"
        width={900}
        footer={null}
        maskClosable={true}
        destroyOnClose={true}
        baseComponent={<ShiftList />}
        baseProps={{ storeId }}
      />
    )
  }
}

export default ShiftListDrawer
